import { RefObject, useEffect } from 'react'

export const useOutsideClick = <T extends HTMLElement | null>(
  ref: RefObject<T>,
  callback: () => void,
  ignoreClickOutOfRoot: boolean = false,
  shouldIgnore?: (target: Node) => boolean,
) => {
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as Node

      // In case ignoreClickOutOfRoot is true and click is outside of the root element we are not calling the callback
      const root = document.getElementById('root')
      if (ignoreClickOutOfRoot && root && !root.contains(target)) return

      if (shouldIgnore?.(target)) return

      if (ref.current && !ref.current.contains(target)) {
        callback()
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [ref, callback, ignoreClickOutOfRoot, shouldIgnore])
}
